import store from '@/store'
import {formatRoutes} from '@/utils/router/other'

// 登录前路由
let baseRouters = [
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register/index')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/login/member',
    name: 'MemberLogin',
    component: () => import('@/views/login/member/index')
  },
  {
    path: '/wx_login/author',
    name: 'WXLogin',
    component: () => import('@/views/login/wx-login/author')
  }
]
export default baseRouters.concat(formatRoutes(store.state.login.routes))

const goNext = (to, next) => {
  if (to.path === '/login' || to.path === '/login/member' || to.path === '/register' || to.path === '/') {
    const homePath = store.state.login.routes[0].children[0].path
    next(homePath)
  } else {
    next()
  }
}

/**
 * 路由拦截
 */
export const corpInterceptor = (to, next) => {
  let goLogin = () => {
    store.dispatch('FedLogOut').then(() => next('/login'))
  }

  const loginData = store.state.login.loginData
  if (loginData && loginData.length > 0) {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
    return
  }

  if (store.state.corporation.userInfo) {
    goNext(to, next)
  } else {
    goLogin()
  }
}

/**
 * 路由拦截
 */
export const memberInterceptor = (to, next) => {
  let goLogin = () => {
    store.dispatch('FedLogOut').then(() => next('/login/member'))
  }

  if (store.state.login.userInfo) {
    goNext(to, next)
  } else {
    goLogin()
  }
}



// WEBPACK FOOTER //
// ./src/router/corporation.js